/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMagnifyingGlassMinus: {
  name: 'magnifying-glass-minus';
  data: string;
} = {
  name: 'magnifying-glass-minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 5a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 14.32 4.906l3.387 3.387a1 1 0 0 1-1.414 1.414l-3.387-3.387A8 8 0 0 1 3 11Zm6-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H9Z" fill="currentColor"/></svg>`,
};
